<template>
    <xx-select v-model="regionId" :list="list" value-key="value" v-bind="$attrs" v-on="$listeners" :placeholder="placeholder"></xx-select>
</template>

<script>
import XxSelect from './index';

export default {
    name: 'XxRegionSelect',
    props: {
        value: {
            required: false
        },
        responseFilter: {
            type: Function,
            default: res => {
                return res;
            }
        },
        setDefault: {
            type: [Boolean, Function],
            default: false
        },
        placeholder: {
            type: String,
            default: '请选择区域'
        }
    },
    data() {
        return {
            regionId: this.value,
            list: []
        };
    },
    components: {
        XxSelect
    },

    watch: {
        regionId(v) {
            this.$emit('input', v);
        },
        value(v) {
            this.regionId = v;
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            return this.$post(`${window.location.origin}/api/resource/getRegionList`).then(res => {
                this.list = this.responseFilter(res).map(item => {
                    return {
                        ...item,
                        value: item.regionId,
                        label: item.regionName
                    };
                });
                if (this.setDefault) {
                    if (typeof this.setDefault === 'function') {
                        this.regionId = this.setDefault(this.list);
                        return;
                    }
                    this.regionId = this.list && this.list[0] && this.list[0].regionId;
                }
            });
        }
    }
};
</script>
